import React, { useState, useEffect } from 'react';
import { Grid, TextField, MenuItem, Tooltip, IconButton, Box, Typography, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import axios from '../axios';

const AlunnoSelector = ({ idCorso, onAlunnoAdded }) => {
    const [alunni, setAlunni] = useState([]);
    const [selectedAlunno, setSelectedAlunno] = useState('');

    useEffect(() => {
        fetchAlunni();
    }, []);

    const fetchAlunni = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await axios.post('/datahandler/alunni-insegnante', { token });
            setAlunni(response.data);
        } catch (error) {
            console.error('Error fetching alunni:', error);
        }
    };

    const handleAddAlunno = async () => {
        if (!selectedAlunno) return;
        const token = localStorage.getItem('token');
        try {
            await axios.post('/datahandler/add-alunno-al-corso', {
                idCorso: idCorso,
                idAlunno: selectedAlunno,
                token
            });
            onAlunnoAdded(); // Chiama la funzione di aggiornamento nel componente padre
            setSelectedAlunno('');
        } catch (error) {
            console.error('Error adding alunno to corso:', error);
        }
    };

    return (
        <Box sx={{
            p: 2.5,
            borderRadius: '16px',
            background: 'rgba(255, 255, 255, 0.3)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.45)',
            boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
            mt: 3,
            mb: 1
        }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#444', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <PersonAddIcon sx={{ color: '#ff9800', fontSize: 20 }} />
                Aggiungi un DinoAlunno al corso
            </Typography>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={8}>
                    <TextField
                        select
                        label="Scegli un alunno"
                        value={selectedAlunno}
                        onChange={(e) => setSelectedAlunno(e.target.value)}
                        fullWidth
                        size="small"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                '&:hover': {
                                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                },
                            }
                        }}
                    >
                        {alunni.length > 0 ? (
                            alunni.map((alunno) => (
                                <MenuItem key={alunno.id} value={alunno.id}>
                                    {alunno.first_name} {alunno.last_name}
                                </MenuItem>
                            ))
                        ) : (
                            <MenuItem disabled>Caricamento alunni...</MenuItem>
                        )}
                    </TextField>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Button
                        variant="contained"
                        onClick={handleAddAlunno}
                        disabled={!selectedAlunno}
                        fullWidth
                        className="btn-3d btn-3d-dark-orange"
                        sx={{ height: 40 }}
                    >
                        Associa
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default AlunnoSelector;
